import alarmSituationUtils from '@/pages/Processes/AlarmSituations/alarmSituations.utils.ts'
import alarmSituationInputFormulaConstants from './alarmSituationInputFormula.constants.ts'
import css from './alarmSituationInputFormula.module.css'
import { IAlarmSituationFormulaToken } from '@/pages/Processes/AlarmSituations/alarmSituations.types.ts'

/** Превратить строку ввода в набор html-элементов, каждый из которых является частью формулы, после чего вставить эти части в переданный контейнер */
const formatFormulaTextAndInsertIntoElement = (text: string, container: HTMLDivElement) => {
  const tokens = alarmSituationUtils.splitFormulaTokens(text)
  while (container.firstChild) {
    container.removeChild(container.firstChild)
  }
  tokens.forEach((token) => {
    const span = document.createElement('span')
    if (alarmSituationInputFormulaConstants.operators.includes(token)) {
      span.className = css.operator
    } else if (!isNaN(Number(token))) {
      span.className = css.number
    } else {
      span.className = css.parameter
    }
    span.textContent = token
    container.appendChild(span)
  })
}

/** Преобразовать текст формулы в набор токенов */
const parseFormulaTextIntoTokens = (text: string): IAlarmSituationFormulaToken[] => {
  const tokens = alarmSituationUtils.splitFormulaTokens(text)

  return tokens.map((token) => {
    if (alarmSituationInputFormulaConstants.operators.includes(token)) {
      return { type: 'operator', value: token } as const
    } else if (!isNaN(Number(token))) {
      return { type: 'constant', value: token } as const
    } else {
      return { type: 'parameter', value: token } as const
    }
  })
}

const alarmSituationFormulaInputUtils = { formatFormulaTextAndInsertIntoElement, parseFormulaTextIntoTokens }
export default alarmSituationFormulaInputUtils
